import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService, CalendarService, TranslatorService, FieldService } from '../../../services';
import { ModalComponent } from '../../modal/modal.component';
import { Condition } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscSalesDetailComponent } from '../usc-sales-detail/usc-sales-detail.component';

@Component({
    selector: 'sn-usc-p2w-sales-details',
    templateUrl: '../usc-sales-detail/usc-sales-detail.component.html',
    styleUrls: ['../usc-sales-detail/usc-sales-detail.component.css']
  })
    
export class UscP2wSalesDetailsComponent extends UscSalesDetailComponent {
    @Input() current_month: string;

    ngOnInit() {
        this.isPreviousMonthEnabled = !this.uscStoreService.isUSCellAgent();

        if (this.isPreviousMonthEnabled) {
            this.uscStoreService.loadPreviousActionPlans();
            this.uscStoreService.previousActionPlansLoaded.subscribe(bLoaded => {
                if (bLoaded) this.available_months = this.uscStoreService.getAvailableActionPlanMonths(current_user);
            })
        }

        this.enabled_include_todays_sales = false;
        this.enabled_scope_ranking = true;
        super.ngOnInit();

        this.current_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.current_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_previous_month = this.current_month != this.uscStoreService.getThisMonthActionPlanSubject();
        var current_user = this.authService.getActive();
    }

    updateDetailedResults(month:string) {
        this.current_month = month;
        this.is_current_month = this.current_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_previous_month = this.current_month != this.uscStoreService.getThisMonthActionPlanSubject();
        this.reloadItems();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-sales-details/usc-p2w-sales-details.component.ts